import { ReactNode } from 'react';
import classNames from '@/helpers/classNames';

interface IInfoPanelFooter {
  children: ReactNode;
  className?: string;
  wrapClassName?: string;
  childrenClassName?: string;
  fullWidth?: boolean;
}

export default function InfoPanelFooter({
  children,
  className = '',
  wrapClassName = 'fixed left-0 bottom-0 w-full bg-white border-t border-gray-300 shadow-sm transition transition-bottom overflow-x-auto md:w-footer',
  childrenClassName = 'px-4 py-3.5 w-full md:w-auto',
  fullWidth = false,
}: IInfoPanelFooter): JSX.Element {
  return (
    <div
      className={classNames(
        wrapClassName,
        fullWidth ? '' : 'border-l md:left-64',
        className,
      )}
    >
      <div
        className={classNames(
          childrenClassName,
          fullWidth ? 'max-w-7xl mx-auto' : '',
        )}
      >
        {children}
      </div>
    </div>
  );
}
